import { auth, db } from "@/firebase/config"
import { ref } from "vue"
import { onAuthStateChanged } from "firebase/auth"
import { query, doc, getDoc } from "firebase/firestore"
import store from "@/store"

const authUser = ref(auth.currentUser)
const dbUser = ref(null)
const isAdminUser = ref(false)

onAuthStateChanged(auth, async (_user) => {
    authUser.value = null
    dbUser.value = null
    isAdminUser.value = false

    if (_user) {
        try {
            authUser.value = _user
            const q = query(doc(db, "Users", _user.uid))
            const querySnapshot = await getDoc(q)
            const tempUser = querySnapshot.data()
            
            if (tempUser.role.toLowerCase() === 'admin') {
                isAdminUser.value = true
            }
            
            dbUser.value = tempUser
            
            // Now we set the vue state.
            store.commit('setUser', dbUser.value)
            store.commit('setIsAdmin', isAdminUser.value)
        } catch (err) {
            console.error(err.message)
            dbUser.value = null
        }
    }
    else {
        store.commit('setUser', null)
        store.commit('setIsAdmin', false)
    }
})

const getUser = () => {
    return { authUser, dbUser, isAdminUser, }
}

export default getUser
